import { useState, useEffect } from "react";

interface P {
    target: number
    duration?: number
}

const formatNumber = (n: number): string =>
    new Intl.NumberFormat('de-CH').format(Math.round(n));

const getCounterScale = (value: number): number => {
    const digits = String(Math.abs(Math.round(value))).length;
    if (digits <= 4) return 1;
    if (digits <= 5) return 0.85;
    if (digits <= 6) return 0.72;
    return 0.6;
};

const Counter = ({ target, duration = 2000 }: P) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        if (count >= target) return;

        const increment = Math.ceil(target / (duration / 50)); // Adjust increment
        const interval = setInterval(() => {
            setCount((prev) => {
                const nextValue = prev + increment;
                return nextValue >= target ? target : nextValue;
            });
        }, 50); // Update every 50ms

        return () => clearInterval(interval);
    }, []);

    const scale = getCounterScale(target);

    return (
        <div
            className="counter-value"
            style={{ '--counter-scale': scale } as React.CSSProperties}
        >
            {formatNumber(count)}
        </div>
    );
};

export { formatNumber, getCounterScale };
export default Counter;
